import React from 'react';
import styled from 'styled-components';
import { Box, Tooltip } from '@99designs/emu';
import { colors, typography } from '@99designs/emu/settings';
import { Icon } from '@99designs/frontend-components/components/Icon';
import { Card } from './Card';
import { Field as DefaultField } from './FormField';

const Footnote = styled.p`
    font-size: ${typography.fontSizes.paragraphs.small}px;
    color: ${colors.typography.soft};
`;

function HelpTooltip({ children }: { children: React.ReactNode }) {
    const style = {
        fontSize: typography.fontSizes.root,
        color: colors.typography.softer,
    };

    const contents = <div style={{ maxWidth: 300, textAlign: 'center' }}>{children}</div>;

    return (
        <Tooltip title={contents} placement="top">
            <span style={style}>
                <Icon type={'question-mark-1'} variations={['offset-left']} />
            </span>
        </Tooltip>
    );
}

interface Props {
    id?: string;
    tooltip?: string;
    title: string;
    message?: React.ReactElement | string;
    required?: boolean;
    error?: string;
    children: React.ReactNode;
    withoutCardWrapper?: boolean;
    footnote?: string;
}

function Field({
    id,
    title,
    message,
    tooltip,
    required,
    error,
    children,
    withoutCardWrapper = false,
    footnote,
}: Props) {
    const titleWithTooltip = (
        <span>
            {title}
            {required && '\u00A0'}
            {required && <span className="required">*</span>}
            {tooltip && '\u00A0'}
            {tooltip && <HelpTooltip>{tooltip}</HelpTooltip>}
        </span>
    );

    return withoutCardWrapper ? (
        <Box id={id}>
            <DefaultField errorMessage={error} title={titleWithTooltip} message={message}>
                {children}

                {footnote && <Footnote>{footnote}</Footnote>}
            </DefaultField>
        </Box>
    ) : (
        <Card id={id} variations={['field']}>
            <Card.Block>
                <DefaultField
                    errorMessage={error}
                    title={titleWithTooltip}
                    variations={['jumbo-title']}
                    message={message}
                >
                    {children}
                    {footnote && <Footnote>{footnote}</Footnote>}
                </DefaultField>
            </Card.Block>
        </Card>
    );
}

export default Field;
